var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.25577C0.103105 3.9323 0.22769 3.62609 0.489748 3.3932C0.927944 2.99642 1.56805 2.8886 2.10935 3.13012C2.66354 3.38026 3.01152 3.93662 3.00293 4.5361C3.00293 4.60942 3.05019 4.71724 3.11033 4.74743C4.50654 5.45473 5.90705 6.15772 7.33763 6.87365C8.28705 5.51511 9.23648 4.15657 10.1988 2.78078C9.73482 2.44438 9.47706 2.00016 9.50283 1.42655C9.52002 1.02546 9.68327 0.676122 9.97969 0.400101C10.5854 -0.164879 11.5434 -0.126064 12.1019 0.482045C12.7249 1.16347 12.6175 2.03897 11.8055 2.78941C12.7506 4.14363 13.7001 5.49786 14.6538 6.86503C14.7182 6.83915 14.7784 6.81758 14.8342 6.79171C16.1703 6.12322 17.5063 5.45042 18.8424 4.78193C18.9283 4.7388 19.01 4.71293 19.0057 4.5706C18.9842 3.76842 19.5384 3.11718 20.316 3.01799C21.0678 2.9231 21.7551 3.40183 21.957 4.1652C21.9656 4.1997 21.9828 4.22989 22 4.26008C22 4.43259 22 4.60511 22 4.77762C21.9742 4.84231 21.9484 4.907 21.9227 4.9717C21.7465 5.4763 21.4114 5.81701 20.8916 5.94639C20.7155 5.98952 20.6596 6.07578 20.621 6.23967C20.1054 8.42196 19.577 10.5999 19.0658 12.7822C19.0143 13.0022 18.9197 13.041 18.7221 13.041C15.7149 13.0367 12.7077 13.0367 9.70475 13.0367C7.55673 13.0367 5.40871 13.0324 3.26069 13.041C3.05019 13.041 2.97715 12.9763 2.93849 12.7822C2.83538 12.2862 2.7065 11.7946 2.58621 11.2986C2.18239 9.59936 1.77426 7.9001 1.37473 6.20085C1.34036 6.05853 1.28022 5.99384 1.13415 5.95933C0.592853 5.82132 0.244874 5.46767 0.0687366 4.93719C0.0515524 4.88544 0.0300723 4.83368 0.00859207 4.78193C0 4.60079 0 4.42828 0 4.25577Z",
    fill: "url(#paint0_linear_340_3458)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9907 14.0439C18.9907 14.5658 18.9993 15.0747 18.9864 15.5836C18.9821 15.8208 18.7974 15.9933 18.5568 16.0192C18.4795 16.0278 18.3978 16.0278 18.3205 16.0278C13.4359 16.0278 8.55563 16.0278 3.67103 16.0278C3.59371 16.0278 3.51208 16.0278 3.43475 16.0192C3.19847 15.989 3.01374 15.8165 3.00515 15.5836C2.99226 15.0747 3.00085 14.5658 3.00085 14.0439C8.33653 14.0439 13.6507 14.0439 18.9907 14.0439Z",
    fill: "url(#paint1_linear_340_3458)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_3458",
    x1: 11,
    y1: 0,
    x2: 11,
    y2: 13.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F84531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_340_3458",
    x1: 10.9958,
    y1: 14.0439,
    x2: 10.9958,
    y2: 16.0278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F84531"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.5a301124ba94f2d39d5011b43c98d0ab.svg";
export { ForwardRef as ReactComponent };